const workbench = {
  dashboardTitle: 'Recruitment Data Center',
  operatingDesk: 'Workbench',
  compactGreeting: '{greeting}, {name}',
  compactSubtitle:
    "Review current credits, talent-pool status, and common actions before continuing today's hiring work.",
  compactSubtitlePool: [
    'Move one strong candidate forward today.',
    'Great candidates do not wait. Line up the next follow-up.',
    'One more reviewed profile can become the right hire.',
    'Sharper screening now makes every outreach easier later.',
    'Find the high-potential talent first, then let the workflow move.',
    'Hiring rewards steady rhythm. Keep the pipeline moving.',
    'Do not let the right candidate sit in pending.',
    'Every precise touch helps the team shorten time-to-hire.',
  ],
  realMetricsTitle: 'Current available data',
  aiMatchPoints: 'AI Credits',
  aiMatchPointsDesc: 'Used for job-candidate match analysis',
  jobQuotaCompactDesc: 'Current available job quota',
  startChecklistTitle: 'New User Tasks',
  startChecklistDesc: 'Complete tasks in order. The next task unlocks automatically afterward.',
  availableJobCount: 'Available Job Count',
  availableJobCountDesc: 'Current quota for new jobs',
  aiRecommendedTalent: 'AI Recommended Talent',
  aiRecommendedTalentDesc: 'Total recommended talent scoring above 85',
  outreachTalent: 'Outreach Talent',
  outreachTalentDesc: 'Total contacted talent',
  onboardingCreateJobTitle: 'Create a recruiting project',
  onboardingCreateJobDesc: 'Create a job, complete the search strategy, and run one talent match.',
  onboardingRecommendationTitle: 'EasyHire AI recommendation - add talent to job',
  onboardingRecommendationDesc: 'Add 5 candidates from AI recommendations to a job.',
  onboardingLinkedinTitle: 'LinkedIn automated search matching',
  onboardingLinkedinDesc: 'Start one LinkedIn automated search and sync matching results back.',
  onboardingOutreachTitle: 'Automated outreach',
  onboardingOutreachDesc: 'Complete one automated InMail, Email, or connection request touch.',
  onboardingReferralTitle: 'Referral rewards',
  onboardingReferralDesc:
    'Invite a friend to create a new account through your link. The first qualified invite completes this task.',
  onboardingLocked: 'Locked',
  onboardingClaimReward: 'Claim reward',
  onboardingRewardClaimed: 'Reward claimed',
  rewardAiMatch400: 'AI Credits +400',
  rewardAiMatch200: 'AI Credits +200',
  rewardContact5: 'Contact points +5',
  rewardMembership7: 'Membership +7 days',
  rewardUnlockOutreach: 'Unlock outreach flow',
  rewardReferralBundle: 'Open referral progress',
  taskDone: 'Done',
  taskInstall: 'Install',
  taskStart: 'Start',
  taskOpen: 'Open',
  taskView: 'View',
  taskExtensionTitle: 'Connect browser extension',
  taskExtensionDesc: 'The extension syncs login status and runs LinkedIn page actions.',
  taskCreateJobTitle: 'Create a recruiting project',
  taskCreateJobDesc: 'Use the recruiting conversation to generate a job project.',
  taskCreateJobDoneDesc: '{count} job projects already exist.',
  taskTalentTitle: 'Organize the talent pool',
  taskTalentDesc: 'Manage candidates from all talent or a selected group.',
  taskTalentDoneDesc: '{count} candidates are already in the talent pool.',
  taskPointsTitle: 'Check points balance',
  taskPointsDesc: 'Confirm contact points and AI Credits are available.',
  taskSettingsTitle: 'Set up outreach',
  taskSettingsDesc: 'Manage senders, templates, and shared content.',
  greetingMorning: 'Good morning',
  greetingNoon: 'Good noon',
  greetingAfternoon: 'Good afternoon',
  greetingEvening: 'Good evening',
  greetingTipMorning: 'Good morning. Start the day with steady momentum.',
  greetingTipNoon: 'Good noon. Keep the pace, and do not skip a proper break.',
  greetingTipAfternoon: 'Good afternoon. A good time to push one key task forward.',
  greetingTipEvening: 'Good evening. Wrap up today with one more solid win.',
  greetingTipLateNight: 'It is getting late. Remember to get some rest soon.',
  greetingWithName: '👋 {greeting}, {name}',
  beijingTimeLabel: 'Beijing Time UTC+8',
  utcTimeLabel: 'UTC',
  weekThis: 'This Week',
  exportReport: 'Export Report',
  quotaTitle: 'User rights and interests',
  resumeImport: 'AI Analysis Credits',
  resumeImportDesc: 'Resume import feature coming soon — stay tuned',
  resumeImportPreviewDesc:
    'Supports both individual and batch import modes with intelligent resume parsing and key info extraction.',
  resumeImportIndividual: 'Individual Import',
  resumeImportBatch: 'Batch Import',
  contactPoints: 'Contact Points',
  contactPointsHint: 'Get Email costs 1 pt, get Phone costs 2 pts',
  contactPointsLow: 'Low credits',
  contactPointsRecharge: 'Recharge',
  contactPointsRechargeTitle: 'Contact Sales to Recharge Credits',
  contactPointsRechargeDesc:
    'Your contact credits are running low. Scan the QR code to contact sales and recharge.',
  pointsUnit: 'pts',
  currentActivityTitle: 'Current Activity',
  candidatesInTalentPool: 'Candidates in Talent Pool',
  candidatesInTalentPoolDesc:
    'Centralized candidate management with tag filtering and batch actions',
  jobManageCount: 'Manageable Job Count',
  jobManageCountDesc: 'Upgrade to Enterprise Basic for unlimited job slots',
  metricsAddedFriends: 'New Connections',
  metricsAccepted: 'Accepted This Week',
  metricsAcceptanceRate: 'Acceptance Rate This Week',
  metricsPending: 'Current Pending Count',
  metricsVsLastWeek: 'vs last week',
  metricsRefresh: 'Refresh',
  delayedAcceptanceTitle: 'Delayed Acceptance Analysis',
  delayedAcceptanceSubtitle: 'Distribution of the 75 accepted candidates this week',
  delayedAcceptanceLegendThisWeek: 'Sent This Week',
  delayedAcceptanceLegendLastWeek: 'Sent Last Week',
  delayedAcceptanceLegendEarlier: 'Sent Earlier',
  delayedAcceptanceLegendValue: '{count} people ({percentage}%)',
  delayedAcceptanceInsightLabel: 'Insight:',
  delayedAcceptanceInsightText:
    'LinkedIn hiring shows clear delayed conversion. 52% of acceptances come from earlier outreach. Keep a stable outreach cadence.',
  weeklyComparisonTitle: 'Weekly Sent & Accepted Comparison',
  weeklyComparisonPeriod: 'Period',
  weeklyComparisonSent: 'Sent',
  weeklyComparisonAccepted: 'Accepted',
  weeklyComparisonPending: 'Pending',
  weeklyComparisonRate: 'Acceptance Rate',
  weeklyComparisonThisWeek: 'This Week',
  weeklyComparisonLastWeek: 'Last Week',
  weeklyComparisonTwoWeeksAgo: 'Two Weeks Ago',
  weeklyComparisonInsightLabel: 'Trend:',
  weeklyComparisonInsightText:
    'Sent volume increased by 25.4% week-over-week, but the acceptance rate dipped slightly. Consider optimizing candidate filtering.',
  aiToolsTitle: 'AI Recruiting Tools',
  aiToolAgentTitle: 'Recruiting AI Automation Search',
  aiToolAgentDesc:
    'Enter a hiring need, generate a search strategy, and open LinkedIn search for Business, Sales, or Recruiter accounts.',
  aiToolAgentEnterpriseHint: 'Membership required',
  aiToolJdTitle: 'Natural Language Job Creation',
  aiToolJdDesc:
    'Describe your hiring needs in plain language. AI auto-parses and generates complete job details.',
  aiToolMatchTitle: 'Job Candidate Matching',
  aiToolMatchDesc:
    'After candidates enter a job, AI analyzes match score, strengths, risks, and recent insights.',
  aiToolMatchPreviewDesc:
    'AI compares job requirements with candidate resumes and returns match scores, ratings, strengths, risks, and recent insights so teams can prioritize follow-up faster.',
  aiToolEnterpriseOnly: 'Enterprise',
  zoomTip: 'Tip: Hold Ctrl + Mouse Wheel to zoom for the best viewing experience',
  extensionTip: 'Tip: Extension not detected, some features are unavailable',
  extensionInstall: 'Click to install extension',
  aiToolReportTitle: 'Job Talent Report',
  aiToolReportDesc:
    'Review job-level candidate match results, recommendation reasons, risks, and detailed analysis.',
  aiToolReportPreviewDesc:
    'Generate structured talent reports from job candidate match analysis, including match score, rating, strengths, risks, recent insights, and detailed analysis.',
  aiToolExportTitle: 'Excel Export',
  aiToolExportDesc:
    'Export candidates by talent-pool tag or job, including current role, latest company, and match analysis fields.',
  aiToolExportPreviewDesc:
    'Export Excel files from talent-pool tags or job lists. Job exports include match score, rating, strengths, risks, recent insights, and detailed analysis; tag exports focus on candidate profile and experience fields.',
  helpTitle: 'Help & Support',
  helpCenter: 'Visit Help Center →',
  helpGuideTitle: 'Quick Start Guide',
  helpGuideDesc: 'Set up account type, Extension, jobs, and your talent pool.',
  helpGuideContent:
    '1. Set your LinkedIn account type in Profile settings\n2. Install and enable EasyHire AI Extension, keeping the current account signed in\n3. Create a job or talent-pool tag and define the candidate scope\n4. Use Recruiting AI to generate a search strategy and launch the matching LinkedIn search mode\n5. After collecting candidates, review match analysis, reports, and Excel exports from the talent pool or job page',
  helpVideoTitle: 'Video Tutorials',
  helpVideoDesc:
    'Learn the full flow from search strategy to candidate collection, matching, and export.',
  helpVideoEmpty: 'Video tutorials are coming soon. Stay tuned!',
  helpFaqTitle: 'FAQ',
  helpFaqDesc: 'Common questions about automation search, account types, points, and exports.',
  helpFaqContent:
    "Q: How are contact points deducted?\nA: Getting a candidate's email costs 1 point, phone number costs 2 points.\n\n" +
    'Q: Why is automation search unavailable?\nA: Automation search requires an active membership and depends on EasyHire AI Extension to sync login status and run LinkedIn recruiting actions.\n\n' +
    'Q: How does LinkedIn account type affect search?\nA: Business, Sales, and Recruiter open different LinkedIn search pages. Set the current account type in Profile settings first.\n\n' +
    'Q: What is the difference between job export and talent-pool tag export?\nA: Job export includes match score, rating, strengths, risks, recent insights, and detailed analysis. Tag export focuses on candidate profile and experience fields.\n\n' +
    'Q: Are there usage limits for AI matching?\nA: Each plan has monthly, quarterly, or annual AI matching quotas. Please refer to the subscription page for details.\n\n' +
    'Q: How can I get more points?\nA: Purchase a plan to receive points, or invite friends to create new accounts and earn rewards at the 1st, 3rd, and 5th qualified invite.',
  helpContactTitle: 'Contact Account Manager',
  helpContactDesc: 'Get 1-on-1 guidance and customized enterprise solutions.',
  helpContactScan:
    'Scan the QR code to add your dedicated account manager for 1-on-1 guidance and customized enterprise solutions.',
}

export default workbench
